<div class="grid l_flex-justify-center">
  <section class="guts-m-full-3 grid__col-sm-7 center-text">
    <h1 class="h1 guts-m-b-2">{{ i18n.Pathways_NoAccessHeaderText }}</h1>
    @if (badUrl?.trim()) {
      <p class="tw-font-bold tw-text-red-800">
        {{ badUrl }}
      </p>
    }
    <p class="par guts-m-b-1">
      {{ i18n.Pathways_NoAccessDescriptionText | htmlToPlaintext }}
    </p>
    <p *ngIf="backButton" class="par">
      <a
        [href]="backButton.href"
        class="btn btn-primary"
        data-dgat="forbidden-2cd"
        >{{ backButton.label }}
      </a>
    </p>
    <br />
  </section>
</div>
